(function () {

  /* ================= PAGE GUARD ================= */
  if (window.location.pathname !== '/pages/get-your-quote') return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {

    const BRAND = '#FFD400';

    const STOP_WORDS = [
      'repair','repairs','service','services','installation','install',
      'replacement','replace','work','works','contractor','contractors',
      'fix','fixing','build','building'
    ];

    const STATE = {
      step: 0,
      answers: {
        desc: '',
        service: '',
        city: '',
        province: '',
        postal: '',
        timeline: ''
      }
    };

    /* ================= MOUNT ================= */
    let root = document.getElementById('tm-root');
    if (!root) {
      root = document.createElement('div');
      root.id = 'tm-root';
      (document.querySelector('main') || document.body).prepend(root);
    }

    root.innerHTML = `
<style>
#tm-root{position:fixed;inset:0;display:flex;justify-content:center;align-items:center;background:#f3f4f6;z-index:999}
#tm-root *{font-family:Poppins,system-ui;box-sizing:border-box}
.tm-device{position:relative;padding:4px;background:#000;border-radius:35px;box-shadow:0 0 0 6px #111,0 25px 80px rgba(0,0,0,.6)}
.tm-device::before{content:'';position:absolute;top:4px;left:50%;transform:translateX(-50%);width:160px;height:28px;background:#000;border-radius:0 0 18px 18px}
.tm-device::after{content:'';position:absolute;bottom:10px;left:50%;transform:translateX(-50%);width:120px;height:5px;background:#444;border-radius:999px;opacity:.7}
.tm-phone{width:390px;max-width:94vw;height:820px;max-height:88vh;background:#fff;border-radius:34px;overflow:hidden;display:flex;flex-direction:column}
.tm-header{padding:28px 14px 14px;border-bottom:1px solid #eee;display:flex;gap:10px;align-items:center}
.tm-header img{width:38px;height:38px;border-radius:50%}
.tm-body{flex:1;overflow:auto;padding:18px}
.tm-footer{padding:12px;border-top:1px solid #eee}
.tm-btn{width:100%;background:${BRAND};border:none;padding:14px;border-radius:999px;font-weight:800;cursor:pointer;margin-bottom:12px;color: #000; text-decoration: none;}
.tm-back{background:#e5e7eb;color:#111}
.tm-bubble{background:#f1f5f9;border-radius:18px;padding:14px;margin-bottom:12px;font-size:15px;color:#000000;}
.tm-bubble span{font-size: 12px; display:block;padding-top:5px;}
.tm-field{width:100%;padding:14px;border-radius:14px;border:1px solid #ddd;margin-bottom:10px}
.tm-card-btn{border:1px solid #ddd;border-radius:16px;padding:14px;margin-bottom:10px;cursor:pointer}
.tm-muted{font-size:13px;color:#6b7280;margin-top:4px}
.tm-result-card{border:1px solid #eee;border-radius:18px;padding:14px;margin-bottom:18px; background:#f3f9ff;
}
.tm-stars{color:#FBBF24}
</style>

<div class="tm-device">
  <div class="tm-phone">
    <div class="tm-header">
  <div style="display:flex;align-items:center;gap:10px;">
    <img src="https://cdn.shopify.com/s/files/1/0698/4695/8394/files/Screen_Shot_2025-12-10_at_8.28.18_PM.png?v=1765416517">
    <strong>Conrad · TradeMatch Guide</strong>
  </div>

  <div id="tm-step-indicator" style="
    margin-left:auto;
    font-size:11px;
    font-weight:500;
    color:#121212;
    background: #ffd400;
    padding: 9px;
    border-radius: 15px;
  ">
  </div>
</div>
    <div class="tm-body" id="tm-body"></div>
    <div class="tm-footer">
      <button class="tm-btn tm-back" id="tm-back" style="display:none">Back</button>
      <button class="tm-btn" id="tm-next">Next</button>
    </div>
  </div>
</div>
`;

    const body = root.querySelector('#tm-body');
    const nextBtn = root.querySelector('#tm-next');
    const backBtn = root.querySelector('#tm-back');

    function render() {
      body.innerHTML = '';
      const stepIndicator = document.getElementById('tm-step-indicator');

if (stepIndicator) {
  if (STATE.step >= 0 && STATE.step <= 5) {
    if (STATE.step === 5) {
      stepIndicator.innerText = 'Result';
    } else {
      stepIndicator.innerText = `Step ${STATE.step + 1} of 6`;
    }
  } else {
    stepIndicator.innerText = '';
  }
}
      backBtn.style.display = (STATE.step > 0 && STATE.step < 5) ? 'block' : 'none';
      nextBtn.style.display = STATE.step < 4 ? 'block' : 'none';

      if (STATE.step === 0) {
        body.innerHTML = `
<div class="tm-bubble" style="font-size:18px"><strong>Let’s start with what’s going on at your home</strong><span>Describe the issue in your own words — you don’t need to know the service name.</span></div>
<textarea class="tm-field" id="desc" placeholder="e.g. brick repair">${STATE.answers.desc}</textarea>`;
      }

      if (STATE.step === 1) {
        const services = [
          ['Carpentry','Wood structures, stairs, framing'],
          ['Electrical','Wiring, lighting, panels'],
          ['Plumbing','Leaks, drains, pipes'],
          ['HVAC','Heating & cooling systems'],
          ['Roofing','Shingles, leaks, repairs'],
          ['Masonry','Brick, stone, veneer'],
          ['Landscaping','Yards & outdoor work'],
          ['Painting','Interior & exterior'],
          ['Flooring','Hardwood, tile, carpet'],
          ['Drywall','Wall repairs & installs'],
          ['Insulation','Attic & basement'],
          ['Windows & Doors','Repairs & installs'],
          ['Siding','Exterior protection'],
          ['Concrete','Slabs & foundations'],
          ['Tile & Stone','Bathrooms & kitchens'],
          ['Decks & Fences','Outdoor builds'],
          ['Gutters','Install & repair'],
          ['Pest Control','Insects & rodents'],
          ['Appliance Repair','Home appliances'],
          ['General Handyman','Small fixes'],
          ['Excavation','Ground work'],
          ['Tree Services','Trim & removal'],
          ['Waterproofing','Basement protection']
        ];
        body.innerHTML = `
<div class="tm-bubble" style="font-size:18px"><strong>Which of these looks closest</strong>
<span>Based on what you described, this helps us narrow it down.</span></div>
${services.map(([t,d])=>`
<div class="tm-card-btn" data-v="${t}">
<strong>${t}</strong>
<div class="tm-muted">${d}</div>
</div>`).join('')}`;
        body.querySelectorAll('.tm-card-btn').forEach(b=>{
          b.onclick=()=>{STATE.answers.service=b.dataset.v;STATE.step++;render();}
        });
      }

      if (STATE.step === 2) {
  body.innerHTML = `
<div class="tm-bubble" style="font-size:18px"><strong>Where should we look for the best options?</strong><span>Enter your postal code.</span></div>
<!-- <input class="tm-field" id="city" placeholder="City"> -->
<!-- <input class="tm-field" id="province" placeholder="Province"> -->
<input class="tm-field" id="postal" placeholder="Postal code">`;
}

      if (STATE.step === 3) {
        body.innerHTML = `
<div class="tm-bubble" style="font-size:18px"><strong>When would you like this done?</strong><span>This helps us match you with the right timing.</span></div>
${['As soon as possible','Within 1–2 weeks','Flexible — show me the best option'].map(v=>`
<div class="tm-card-btn" data-v="${v}">${v}</div>`).join('')}`;
        body.querySelectorAll('.tm-card-btn').forEach(b=>{
          b.onclick = () => {
  STATE.answers.timeline = b.dataset.v;
 STATE.step = 4; // jump directly to results
  render();
};
        });
      }
if (STATE.step === 4) {
  body.innerHTML = `
 <h2 style="font-size:18px;font-weight: 600; margin-bottom:0px;">Your Best Matches</h2>
<p style="font-size:14px; margin-top: 5px;">We’re finding the best options based on what you told us</p>

  <div style="display:flex;align-items:center;gap:6px;margin:10px 0 20px;">
    <span style="font-size:13px;color:#6b7280;">Our TradeMatch AI is analyzing your request</span>
    <span class="tm-typing"></span>
  </div>
  <p style="margin-top:15px;font-size:13px;color:#6b7280;">
  This usually takes a few seconds.
  </p>
  <div class="tm-load-wrap">
  <div class="tm-load-item"><span>✔</span> Understanding your project</div>
  <div class="tm-load-item"><span>✔</span> Checking local availability</div>
  <div class="tm-load-item"><span>✔</span> Matching the right services</div>
  <div class="tm-load-item"><span>✔</span> Preparing your best options</div>
</div>

  

  <style>
.tm-load-wrap{
  margin-top:20px;
}

.tm-load-item{
  opacity:0;
  transform:translateY(10px);
  margin-bottom:14px; /* more spacing */
  font-size:14px; /* slightly smaller */
  display:flex;
  align-items:center;
  gap:8px;
}

.tm-load-item span{
  color:#22c55e; /* green check */
  font-weight:700;
  font-size:15px;
}

.tm-load-item.show{
  opacity:1;
  transform:translateY(0);
  transition:all 1s ease; /* smoother */
}

  .tm-typing::after{
    content:'';
    display:inline-block;
    width:6px;height:6px;margin-left:3px;
    border-radius:50%;
    background:#000;
    box-shadow:10px 0 0 #000,20px 0 0 #000;
    animation:typingDots 1.4s infinite;
  }

  @keyframes typingDots{
    0%{box-shadow:10px 0 0 #000,20px 0 0 #000}
    33%{box-shadow:10px 0 0 transparent,20px 0 0 #000}
    66%{box-shadow:10px 0 0 transparent,20px 0 0 transparent}
    100%{box-shadow:10px 0 0 #000,20px 0 0 #000}
  }
  </style>
  `;

  const items = body.querySelectorAll('.tm-load-item');

  items.forEach((el,i)=>{
  setTimeout(()=>{
    el.classList.add('show');
  }, i * 1200); // slower timing
});

  setTimeout(()=>{
    STATE.step = 5;
    render();
  },10000);

  return;
}
      if (STATE.step === 5) {
  body.innerHTML = `
<h2 style="font-size: 18px; font-weight: 600; margin-bottom:0px;">Based on what you told us, here’s what we recommend.</h2>
<p style="font-size: 14px; margin-top: 5px;">We’ve narrowed this down based on your project, timing, and location.</p>
<div id="tm-tags" style="display:flex; gap:8px; flex-wrap:nowrap; overflow-x:auto; -webkit-overflow-scrolling:touch; margin:12px 0 18px; padding-bottom:4px;  /* Hide scrollbar */
  scrollbar-width: none;        /* Firefox */
  -ms-overflow-style: none;     /* IE / Edge */
"></div>

<div style="display:flex;justify-content:center;margin:20px 0;">
  <div class="tm-dots-loader">
    <span></span>
    <span></span>
    <span></span>
  </div>
</div>

<style>
.tm-dots-loader{
  display:flex;
  gap:10px;
}
.tm-dots-loader span{
  width:10px;
  height:10px;
  border-radius:50%;
  background:#FFD400;
  animation:dotPulse 1.4s infinite ease-in-out;
}
.tm-dots-loader span:nth-child(2){
  animation-delay:0.2s;
}
.tm-dots-loader span:nth-child(3){
  animation-delay:0.4s;
}

@keyframes dotPulse{
  0%,80%,100%{transform:scale(0.6);opacity:0.5;}
  40%{transform:scale(1);opacity:1;}
}
</style>

<div id="tm-results"></div>

<button class="tm-btn tm-back" id="tm-restart" style="margin-top:20px; display:none;">
Restart Quiz
</button>

<style>
.loader {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  position: relative;
  animation: rotate 1s linear infinite;
}
.loader::before,
.loader::after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 5px solid #a3a3a3;
  animation: prixClipFix 2s linear infinite;
}
.loader::after {
  border-color: #FFD400;
  inset: 6px;
  animation: prixClipFix 2s linear infinite, rotate 0.5s linear infinite reverse;
}
.tm-muted.price-right {
    width: 34%;
    float: left;
    padding-left: 19px;
    text-align: right;
    font-size:12px;
}
    .tm-cardtitle {
    width: 63%;
    float: left;
}
    .tm-stars, .tm-muted {
    display: block;
    width: 100%;
    float: left;
}
    .result-tile {
    background:rgb(255, 255, 255);
    float: left;
    width: 100%;
    margin-bottom: 35px;
    padding: 9px;
    border-radius: 9px;
    border: 1px solid #efefef;
}
    .result-card-header {
    background: #f1f5f9a3;
    float: left;
    width: calc(100% + 20px);
    margin-left: -10px;
    margin-top: -10px;
    border-radius: 9px 9px 0 0;
    padding: 0 10px;
    margin-bottom: 15px;
}
    .otherservice{
    float: left;
    width: 100%;
    }
    .tm-muted.availability {
    max-width: 50%;
    padding-top: 20px;
}
    .statictext {
    font-size: 9px;
    float: left;
    width: 100%;
}
    #tm-tags::-webkit-scrollbar {
  display: none;
}
.abl_wraaper {
    float: left;
    /*width: 50%;*/
    padding-bottom: 10px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #dddcdc;
}
.abl_wraaper .tm-muted.availability {
    max-width: 100%;
    padding-top: 2px;
}
@keyframes rotate {
  0% { transform: rotate(0deg) }
  100% { transform: rotate(360deg) }
}
@keyframes prixClipFix {
  0%   { clip-path: polygon(50% 50%,0 0,0 0,0 0,0 0,0 0) }
  25%  { clip-path: polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0) }
  50%  { clip-path: polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%) }
  75%  { clip-path: polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%) }
  100% { clip-path: polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0) }
}
</style>
`;

  loadResults();

  document.getElementById('tm-restart').onclick = () => {
    STATE.step = 0;
    STATE.answers = {
      desc: '',
      service: '',
      city: '',
      province: '',
      postal: '',
      timeline: ''
    };
    render();
  };
}


    }

   nextBtn.onclick = () => {
  if (STATE.step === 0) {
    STATE.answers.desc = document.getElementById('desc').value;
  }

  if (STATE.step === 2) {
    STATE.answers.city = document.getElementById('city')?.value || '';
    STATE.answers.province = document.getElementById('province')?.value || '';
    STATE.answers.postal = document.getElementById('postal')?.value || '';
  }

  STATE.step++;
  render();
};


    backBtn.onclick = () => {
      STATE.step--;
      render();
    };

    async function loadResults() {

      const normalize = s => s.toLowerCase().replace(/[^a-z0-9\s]/g,'');
      const queryWords = normalize(STATE.answers.desc)
        .split(/\s+/)
        .filter(w => w.length > 2 && !STOP_WORDS.includes(w));

      const res = await fetch('/collections/tradesmen-sub-services');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html,'text/html');
      const links = [...new Set([...doc.querySelectorAll('a[href*="/products/"]')].map(a=>a.href))];

      const matches = [];
      const used = new Set();

      for (const url of links) {
        const h = await (await fetch(url)).text();
        const d = new DOMParser().parseFromString(h,'text/html');

        const kwMeta = d.querySelector('meta[name="service_keywords"]')?.content;
        if (!kwMeta) continue;

const postalMetaRaw = d.querySelector('meta[name="service_postal_codes"]')?.content || '';
const contractorName = d.querySelector('meta[name="contractor_name"]')?.content || '';
const otherServicesRaw = d.querySelector('meta[name="other_service"]')?.content || '';
const emergencyAvailable = d.querySelector('meta[name="emergency_work_available"]')?.content || '';




if (STATE.answers.postal && postalMetaRaw) {
  // User FSA (first 3 chars of postal code)
  const userFSA = STATE.answers.postal
    .toUpperCase()
    .replace(/\s+/g, '')
    .substring(0, 3);

  // Clean metafield value: ["N2A, N2K, N2L"] → ["N2A","N2K","N2L"]
  const productFSAs = postalMetaRaw
    .replace(/[\[\]"]/g, '')   // remove [, ], "
    .split(',')                // split by comma
    .map(p => p.trim().toUpperCase())
    .filter(Boolean);

  if (!productFSAs.includes(userFSA)) continue;
}


        const keywords = normalize(kwMeta).split(',').map(k=>k.trim());

        const intentMatch = queryWords.some(w =>
          keywords.some(k => k.includes(w))
        );
        if (!intentMatch) continue;

       matches.push({
  title: (d.querySelector('meta[property="og:title"]')?.content || '')
    .replace(/\s*\(Sub-service\)\s*/i, ''),
  contractor: contractorName,
  otherServices: otherServicesRaw,
  emergency: emergencyAvailable, // ✅ NEW
  url,
  price: parseFloat(d.querySelector('meta[name="typical_price"]')?.content || 999999),
  availability: parseInt(d.querySelector('meta[name="availability_days"]')?.content || 999),
  rating: parseFloat(d.querySelector('meta[name="rating"]')?.content || 0)
});


      }

      const pick = (arr, fn) => {
        const item = [...arr].sort(fn).find(x=>!used.has(x.url));
        if (item) used.add(item.url);
        return item;
      };

      const best = pick(matches,(a,b)=>b.rating-a.rating);
      const cheap = pick(matches,(a,b)=>a.price-b.price);
      const fast = pick(matches,(a,b)=>a.availability-b.availability);
      const top  = pick(matches,(a,b)=>b.rating-a.rating);


      const whyText = (heading) => {
  if (heading.includes('Best Fit for Your Situation')) {
    return 'Based on your project details, this is the strongest overall fit.';
  }
  if (heading.includes('Best Value')) {
    return 'If your timing is flexible, this may help you save.';
  }
  if (heading.includes('Fastest Option')) {
    return 'If timing matters most, this gets the job moving sooner.';
  }
  if (heading.includes('Highest Rated')) {
    return 'If peace of mind matters most, this is the strongest quality-first choice.';
  }
  return '';
};
const renderOtherServices = (services) => {
  if (!services) return '';

  const items = services
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

  if (!items.length) return '';

  const id = 'os-' + Math.random().toString(36).substr(2, 9);
  const firstThree = items.slice(0, 3);
  const remaining = items.slice(3);

  return `
    <div style="
      margin:8px 0 10px;
      padding:8px 2px;
      background:#fff;
      border-radius:8px;
      font-size:12px;
    ">
      <div style="
        font-weight:600;
        font-size:12px;
        margin-bottom:6px;
        color:#111;
      ">
        Also Handles:
      </div>

      ${firstThree.map(i => `
        <div style="display:flex;gap:6px;align-items:flex-start;margin-bottom:4px;">
          <span style="color:#22c55e;font-weight:700;">✔</span>
          <span>${i}</span>
        </div>
      `).join('')}

      ${remaining.length ? `
        <div id="${id}" 
             style="
               overflow:hidden;
               max-height:0;
               transition:max-height 0.35s ease;
             ">
          ${remaining.map(i => `
            <div style="display:flex;gap:6px;align-items:flex-start;margin-bottom:4px;">
              <span style="color:#22c55e;font-weight:700;">✔</span>
              <span>${i}</span>
            </div>
          `).join('')}
        </div>

        <div style="margin-top:20px;">
          <span 
            style="color:#29c55e;cursor:pointer;font-weight:600;"
            onclick="
              var el = document.getElementById('${id}');
              var btn = this;

              if(el.style.maxHeight === '0px' || !el.style.maxHeight){
                el.style.maxHeight = el.scrollHeight + 'px';
                btn.innerText = 'Show Less';
              } else {
                el.style.maxHeight = '0px';
                btn.innerText = 'Show More';
              }
            "
          >
            Show More
          </span>
        </div>
      ` : ''}
    </div>
  `;
};
const formatAvailability = (days) => {
  if (!days || isNaN(days)) return '';

  // Convert days → weeks (round up)
  const weeks = Math.ceil(days / 7);

  if (weeks <= 1) {
    return '1 week';
  }

  return `${weeks} weeks`;
};
     const card = (h, p) => p ? `
<div class="result-tile">
     <div class="result-card-header"><h3 style="font-size: 15px; font-weight: 600;">${h}</h3>
<div class="tm-muted" style="font-size:11px; margin-top:-11px;margin-bottom: 10px; color: #000; border-radius: 5px;">
    ${whyText(h)}
  </div></div>
<div class="tm-cardtitle">
    ${p.contractor ? `
    <div class="tm-muted" style="font-size:16px;margin-top:2px; font-weight: 700; color:#000;">
     ${p.title}
    </div>
    <strong style="font-weight: 500;font-size: 12px; color: #9a9b9d">
     Handled by ${p.contractor}
  </strong>
    <div class="tm-stars">★★★★★</div>
  ` : ''}
</div>


  <div class="tm-muted price-right">
    Starting at
    <strong style="font-size: 20px;color: #000;"> $${p.price.toLocaleString()}</strong>
  </div>

  <div class="abl_wraaper">
   <div class="tm-muted availability">
  Average start time: <strong style="font-size: 13px;color: #000;">${formatAvailability(p.availability)}</strong>
</div>
${p.emergency ? `
  <div class="tm-muted availability">
  Emergency: <strong style="font-size: 13px;color: #000;">${p.emergency}</strong>
  </div></div>
   <div class="otherservice">${renderOtherServices(p.otherServices)}</div>
  
  
` : ''}
<div class="statictext" style="text-align:center;" ><i>Final price is confirmed after we review your project.</i></div>
  <a href="${p.url}" 
     class="tm-btn" 
     style="float:right;text-align:center;margin-top:10px;margin-bottom:6px;font-size: 13px;">
     Start This Request </a>
<div class="statictext" style="text-align:center;" >We’ll review this with you before anything is confirmed.</div>
  
</div>
` : '';

const tags = [];

if (STATE.answers.service) {
  tags.push({ icon: '🛠️', text: STATE.answers.service });
}
if (STATE.answers.city) {
  tags.push({ icon: '📍', text: STATE.answers.city });
}
if (STATE.answers.timeline) {
  tags.push({ icon: '⏱️', text: STATE.answers.timeline });
}

const tagsWrap = document.getElementById('tm-tags');
if (tagsWrap) {
  tagsWrap.innerHTML = tags.map(t => `
    <span style="
  display:inline-flex;
  align-items:center;
  gap:6px;
  padding:6px 8px;
  background:#f1f5f9;
  border-radius:999px;
  font-size:13px;
  font-weight:400;
  color:#374151;
  white-space:nowrap;
  flex-shrink:0;
">

      <span>${t.icon}</span>
      <span>${t.text}</span>
    </span>
  `).join('');
}


 document.getElementById('tm-results').innerHTML =
  card('Best Fit for Your Situation', best) +

  // 👇 ADD HEADING ONLY IF MORE CARDS EXIST
  ((cheap || fast || top) 
    ? '<h3 style="font-size:18px;font-weight:600;margin:12px 0 16px;color:#374151;">Other ways to approach this:</h3>' 
    : ''
  ) +

  (cheap ? card('Best Value', cheap) : '') +
  (fast ? card('Fastest Option', fast) : '') +
  (top ? card('Highest Rated', top) : '');




const loader = document.querySelector('.tm-dots-loader');
if (loader) loader.remove();

const restartBtn = document.getElementById('tm-restart');
if (restartBtn) restartBtn.style.display = 'block';



    }

    render();
  }

})();
